import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'commentType' })
export class CommentTypePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'UPLOAD':
        return 'UPLOAD DOCUMENT';
      case 'REQUEST_ACTIVE_CHANGE':
        return 'REQUEST ACTIVATION DOCUMENT';
      case 'APPROVE_DOCUMENT':
        return 'APPROVE DOCUMENT';
      case 'REJECT_DOCUMENT':
        return 'REJECT DOCUMENT';
      default:
        return 'UNKNOWN';
    }
  }
}